import React, { useState, useEffect, useContext } from 'react';
import { RootStoreContext } from '../stores/RootStore';
import { StudyEvaluationParam, StudyEvaluationApproval, WarningLetterDetail, StudyEvaluationList } from '../models/StudyEvaluation';
import { ISelect } from '../models/General';
import Select from "react-select";
import MaterialTable from "material-table";
import { TableIcons } from '../utils/Icons';
import Alert from '../utils/Alert';
import { Form, Field } from "react-final-form";
import axios from "axios";
import StudyEvaluationSummary from "../features/StudyEvaluationSummary";
import CheckModalGPA from "./CheckModalGPA";
import Modal from '@mui/material/Modal';


import { CircleSpinnerOverlay } from 'react-spinner-overlay';

const StudyEvaluationListPage = () => {

    const rootStore = useContext(RootStoreContext);
    const { getProcessList, processApproval, getDiffGpa } = rootStore.studyEvaluationStore;
    const { getInstitution, getCareer, getProgramByInstitution, getSemesterLatest, getSemester, getSemesterCheckUas } = rootStore.commonStore;
    const emplidVal = window.localStorage.getItem('emplid');
    const levelVal = window.localStorage.getItem('levelid');

    const [list, setList] = useState<StudyEvaluationList[]>([])
    const [listSummary, setListSummary] = useState<any>()

    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>('');
    const [career, setCareer] = useState<ISelect[]>();
    const [programByInstitution, setProgramByInstitution] = useState<ISelect[]>();
    const [programByinstitutionVal, setProgramByInstitutionVal] = useState<string>('');
    const spArray = new Array();
    const [sp, setSp] = useState<ISelect[]>();
    const [spVal, setSpVal] = useState<string>('');

    const [emplid, setEmplid] = useState<string>('');
    const [historyId, setHistoryId] = useState<string>('');

    const [status, setStatus] = useState("")
    const [message, setMessage] = useState("")
    const [statusAlert, setStatusAlert] = useState(0)
    const [statusAlertReject, setStatusAlertReject] = useState(0)
    const [btnSave, setBtnSave] = useState(false)
    const [btnApprove, setBtnApprove] = useState(false)
    const [hiddenBtnApprove, setHiddenBtnApprove] = useState(false)
    const [btnExport, setBtnExport] = useState(true)

    const [rejectButton, setRejectButton] = useState(true)
    const [selectionVal, setSelectionVal] = useState(true)
    const [freeActionVal, setFreeActionVal] = useState(false)
    const [statusSummary, setStatusSummary] = useState(false)

    const [showCheckDiffGpaModal, setShowCheckDiffGpaModal] = useState(false)
    const [checkDiffGpaList, setCheckDiffGpaList] = useState<any>()
    const [approveParam, setApproveParam] = useState<any>()
    const [diffGpaNum, setDiffGpaNum] = useState<any>('0')

    const [semesterCode, setSemesterCode] = useState<string>('');
    const [semesterDesc, setSemesterDesc] = useState<string>('');

    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>('');
    const [semesterShownVal, setSemesterShownVal] = useState<ISelect>(); // untuk value yang ditampilkan di user

    const [isLoading, setIsLoading] = useState(false);

    const checkSP = (sp: string) => {
        return sp === "WL1" || sp === "WL2" ? true : false;
    }

    var columns = [
        { title: "history_id", field: "history_id", hidden: true },
        { title: "ID", field: "EMPLID" },
        { title: "Name", field: "NAME_DISPLAY" },
        { title: "Class Of", field: "CLASS_OF" },
        { title: "Program", field: "ACAD_PROGRAM" },
        { title: "Semester", field: "SEMESTER" },
        { title: "Warning Letter", field: "WARNING_LETTER" },
        {
            title: "Reject",
            render: (rowData: any) => (
                <button hidden={checkSP(rowData.WARNING_LETTER)} className="btn btn-secondary" data-toggle="modal" data-target="#modal-reject" onClick={() => reject(rowData)}>Reject</button>
            ),
            hidden: rejectButton
        },
        {
            title: 'Upload Scan File',
            render: (rowData: any) => <FileScan rowData={rowData} />,
            hidden: selectionVal
        }
    ]

    const FileScan = (rowData: any) => {
        return (
            <div className="input-group">
                <div className="custom-file">
                    <input type="file"
                        className="custom-file-input"
                        accept="application/pdf"
                        style={{ width: 200 }}
                        disabled={checkFile(rowData)}
                        onChange={(event: any) => {
                            uploadScan(event.target.files[0], rowData)
                        }} />
                    <label className="custom-file-label">Choose file</label>
                </div>
            </div>
        )
    };

    const checkFile = (rowData: any) => {
        return rowData.rowData.FILENAME != null ? true : false;
    }

    function uploadScan(file: any, rowData: any) {
        const data = new FormData()
        data.append('file', file)
        data.append('EMPLID', rowData.rowData.EMPLID);
        data.append('HISTORYID', rowData.rowData.HISTORY_ID);
        data.append('ACAD_PROG', rowData.rowData.ACAD_PROGRAM);
        data.append('STRM', rowData.rowData.STRM);

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/academic/evaluation-process/import`,
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                //handle success
                setMessage(response.data.message)
                setStatus(response.data.status)
                setStatusAlert(1)
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }

    function exportExcel() {
        const token = window.localStorage.getItem('token');
        let file = `${process.env.REACT_APP_API_URL}/academic/evaluation-process/export/${semesterCode}/${programByinstitutionVal}`;
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        fetch(file, {
            headers,
            method: 'get'

        })
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);

                anchor.href = objectUrl;
                anchor.download = 'WL3 List.xls';
                anchor.click();

                window.URL.revokeObjectURL(objectUrl);
            });
    };

    const handleReject = (values: any) => {
        if (values.remarks != "") {
            const rowData = new Array();
            const param = {
                HISTORY_ID: historyId,
                EMPLID: emplid,
                CREATED_BY: emplidVal
            }
            rowData.push(param)
            const data: StudyEvaluationApproval[] = rowData;
            setBtnSave(true)
            handleApproval(data, 2, values.remarks)
        }
    };

    function reject(event: any) {
        setHistoryId(event.HISTORY_ID)
        setEmplid(event.EMPLID)
    };

    function approve(event: any, approvalStatus: number, remarks: string) {
        setBtnApprove(true)
        handleApproval(event, approvalStatus, remarks)
    };

    function handleApproval(rowData: any, approvalStatus: number, remarks: string) {

        const data: StudyEvaluationApproval[] = rowData;
        const newParam = new Array();
        const checkParam = new Array();

        data.map((item, index) => {
            const param = {
                HISTORY_ID: item.HISTORY_ID,
                EMPLID: item.EMPLID,
                APPROVAL_STATUS: approvalStatus,
                REMARKS: remarks,
                CREATED_BY: emplidVal,
                SP: item.WARNING_LETTER,
                LEVEL: levelVal
            }
            newParam.push(param)

            let param2 = {
                HISTORY_ID: item.HISTORY_ID,
                EMPLID: item.EMPLID,
            }

            checkParam.push(param2)

        })

        //for approval BIA (level = 1), check different GPA from log and khs
        if (levelVal == '1' && approvalStatus == 1) { 
            getDiffGpa({ 'CHECK': checkParam }).then(function (response) {
                if (response.length > 0) {
                    setShowCheckDiffGpaModal(true)
                    setCheckDiffGpaList({ 'CHECK': checkParam })
                    setApproveParam(newParam)
                    setDiffGpaNum(response.length)
                }
                else {
                    //process approval
                    processApprovalFunc(newParam,approvalStatus)
                }
            })
        }
        else {
            //process approval
            processApprovalFunc(newParam,approvalStatus)
        }

    }

    function processApprovalFunc(newParam: any,approvalStatus:any) {

        processApproval(newParam).then(function(response) {
            setMessage(response.message)
            setStatus(response.status)
            setBtnApprove(false)

            if(approvalStatus==1){
                setStatusAlert(1)
            }

            if(approvalStatus==2){
                setStatusAlertReject(1)
            }

            loadData()
        })
    }

    function exportExcelDiffGpa() {
        const token = window.localStorage.getItem('token');
        let file = `${process.env.REACT_APP_API_URL}/academic/evaluation-process/get-diff-gpa-excel/`;
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        fetch(file, {
            headers,
            method: 'post',
            body: JSON.stringify(checkDiffGpaList)
        })
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);

                anchor.href = objectUrl;
                anchor.download = 'GPA_DIFF.xls';
                anchor.click();

                window.URL.revokeObjectURL(objectUrl);

                handleCloseCheckDiffGpaModal()

                setMessage('Download Excel Success')
                setStatus('200')
                setStatusAlert(1)

            });
    };

    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);
        const careerData = getCareer(String(emplidVal), event.value);
        careerData.then(function (result) {
            setCareer(result);
        })
    };

    function handleCareerSelect(event: any) {

        const programByInstitutionData = getProgramByInstitution(String(emplidVal), institutionVal, event.value);
        programByInstitutionData.then(function (result) {
            setProgramByInstitution(result);
        })

        getSemesterData(institutionVal, event.value)

        // const semesterData = getSemesterLatest(institutionVal, event.value);
        // semesterData.then(function(result) {
        //     setSemesterDesc(result[0]['label'])
        //     setSemesterCode(result[0]['value'])
        // })
    };

    function handleSemesterSelect(event: any) {
        setSemesterVal(event.value)
        setSemesterShownVal(event)

        setSemesterCode(event.value)
        setSemesterDesc(event.label)

        if (event.value != "") {

        }
    };

    function handleProgramByInstitutionSelect(event: any) {
        setProgramByInstitutionVal(event.value)
        if (levelVal == "4") {
            setBtnExport(false)
        }
    };


    function handleSPSelect(event: any) {
        setSpVal(event.value)
    };

    const getSemesterData = (institution: string, career: string) => {
        const semesterData = getSemesterCheckUas(institution, career);
        semesterData.then(function (result) {
            //limit semester select
            result.length = 2 // 
            setSemester(result);
        })
    }

    const param: StudyEvaluationParam = {
        INSTITUTION: String(institutionVal),
        PROGRAM: String(programByinstitutionVal),
        SEMESTER: String(semesterCode),
        EMPLID: String(emplidVal),
        SP: String(spVal),
        LEVEL: String(window.localStorage.getItem('levelid'))
    };

    useEffect(() => {

        console.log(levelVal)

        if (levelVal == "4") {
            setSelectionVal(false);
            setFreeActionVal(true);
            setBtnApprove(true);
            setHiddenBtnApprove(true);
        }

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function (result) {
            setInstitution(result);
        })

        const rowSP1 = { label: "1", value: "WL1" }
        const rowSP2 = { label: "2", value: "WL2" }
        const rowSP3 = { label: "3", value: "WL3" }
        spArray.push(rowSP1)
        spArray.push(rowSP2)
        spArray.push(rowSP3)

        setSp(spArray)

        if (levelVal == "2" || levelVal == "3") {
            setRejectButton(false)
        }

        loadData();

    }, [institutionVal, programByinstitutionVal, semesterCode, semesterDesc, status,
        spVal, rejectButton, emplid, historyId, selectionVal, btnExport, freeActionVal,
        statusAlert, statusAlertReject])

    function loadData() {
        if (programByinstitutionVal != "") {
            setIsLoading(true);
        }

        getProcessList(param).then(function (response) {
            if (response != undefined) {

                setList(response.detail)
                setListSummary(response.header)
                if (levelVal != "4")
                    setStatusSummary(true)
            }
            setIsLoading(false);
        })
    }

    const renderDetailHistory = (listWl: any) => {

        const data: WarningLetterDetail[] = listWl['history'];

        return data.map((item, index) => {
            return (
                <React.Fragment>
                    <tr key={index}>
                        <td>{item.SEMESTER_KE}</td>
                        <td>{item.SEMESTER}</td>
                        <td>{item.SKS}</td>
                        <td>{item.IPS}</td>
                        <td>{item.IPK}</td>
                        <td>{item.WARNING_LETTER}</td>
                    </tr>
                </React.Fragment>
            );
        })
    }

    const handleCloseCheckDiffGpaModal = () => {
        setShowCheckDiffGpaModal(false)
        setBtnApprove(false)
    }

    const handleSubmitCheckDiffGpaModal = () => {
        setShowCheckDiffGpaModal(false)
        processApprovalFunc(approveParam,1)

    }

    return (
        <React.Fragment>
            {isLoading
                ? <CircleSpinnerOverlay zIndex={2000} loading={isLoading} color="#00FFFF" />
                : <></>
            }
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Study Evaluation Process</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="modal fade" id="modal-reject">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Reject</h4>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {
                                    statusAlertReject == 1 ?
                                        <> <Alert message={message} status={status} /> </> : <> </>
                                }
                                <Form
                                    onSubmit={handleReject}
                                    render={({ handleSubmit }) => (
                                        <form className="m-t" method="POST" onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <Field name="remarks">
                                                    {({ input, meta }) => {
                                                        return (
                                                            <React.Fragment>
                                                                <textarea {...input} required className="form-control" placeholder="Remarks"></textarea>
                                                                <div className="text-danger">
                                                                    {meta.error && meta.touched && (<span>{meta.error}</span>)}
                                                                </div>
                                                            </React.Fragment>
                                                        );
                                                    }}
                                                </Field>
                                            </div>
                                            <button type="submit" disabled={btnSave} className="btn btn-primary block full-width m-b">Save</button>
                                        </form>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    // keepMounted
                    open={showCheckDiffGpaModal}
                    onClose={handleCloseCheckDiffGpaModal}
                >
                    <CheckModalGPA
                        handleCloseCheckDiffGpaModal={handleCloseCheckDiffGpaModal}
                        exportExcelDiffGpa={exportExcelDiffGpa}
                        handleSubmitCheckDiffGpaModal={handleSubmitCheckDiffGpaModal}
                        diffGpaNum={diffGpaNum}
                    /></Modal>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Career</label>
                                                <Select
                                                    name="career"
                                                    placeholder="Choose Career"
                                                    options={career}
                                                    onChange={handleCareerSelect}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                    value={semesterShownVal}
                                                />
                                            </div>
                                        </div>


                                        {/* <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Latest Semester</label>
                                                <input  disabled={true} type="text" required className="form-control" value={semesterDesc} />
                                            </div>
                                        </div> */}


                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Program</label>
                                                <Select
                                                    name="program"
                                                    placeholder="Choose Program"
                                                    options={programByInstitution}
                                                    onChange={handleProgramByInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Warning Letter</label>
                                                <Select
                                                    name="sp"
                                                    placeholder="Choose Warning Letter"
                                                    options={sp}
                                                    onChange={handleSPSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-1">
                                            <div className="form-group">
                                                <label> &nbsp;</label>
                                                <button hidden={btnExport} onClick={() => exportExcel()} className="btn btn-info" type="button">Export</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        statusSummary ?
                            <>
                                <StudyEvaluationSummary data={listSummary} />
                            </>
                            : <> </>
                    }
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Students List</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            {
                                                statusAlert == 1 ?
                                                    <> <Alert message={message} status={status} /> </> : <> </>
                                            }
                                        </div>
                                    </div>
                                    <MaterialTable
                                        title=""
                                        icons={TableIcons}
                                        columns={columns}
                                        data={list}
                                        options={{
                                            filtering: true,
                                            selection: selectionVal,
                                            emptyRowsWhenPaging: false,
                                            pageSize: 20,
                                            pageSizeOptions: [5, 10, 25, 50],
                                            headerStyle: {
                                                fontWeight: 'bold',
                                            },
                                            rowStyle: rowData => ({
                                                backgroundColor: rowData.tableData.id % 2 === 0 ? "#EEE" : "#FFF",
                                            }),
                                        }}
                                        actions={[
                                            {
                                                tooltip: 'Approve',
                                                icon: () => { return (<button disabled={btnApprove} hidden={hiddenBtnApprove} data-toggle="modal" data-target="#modal-approve" className="btn btn-info"> Approve </button>) },
                                                onClick: (event, rowData) => approve(rowData, 1, ''),
                                                isFreeAction: freeActionVal
                                            }
                                        ]}
                                        detailPanel={rowData => {
                                            return (
                                                <React.Fragment>
                                                    &nbsp;
                                                    <div className="col-12">
                                                        <div className="card">
                                                            <div className="card-header">
                                                                <h3 className="card-title">Study Evaluation History</h3>
                                                            </div>
                                                            <div className="card-body table-responsive p-0">
                                                                <table className="table table-bordered table-striped">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Semester #</th>
                                                                            <th>Semester</th>
                                                                            <th>SKS</th>
                                                                            <th>IPS</th>
                                                                            <th>IPK</th>
                                                                            <th>Warning Letter</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {renderDetailHistory(rowData)}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </section>
        </React.Fragment>
    );
}

export default StudyEvaluationListPage;